import { ApolloLink, split } from '@apollo/client';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { SubscriptionClient } from 'subscriptions-transport-ws';

export const createSplitLink = (httpLink: ApolloLink) => {
  if (process.env.NEXT_PUBLIC_WEBSOCKET_API_ENDPOINT === undefined) {
    throw new Error('NEXT_PUBLIC_WEBSOCKET_API_ENDPOINT env not defined');
  }

  const wsLink = new WebSocketLink(
    new SubscriptionClient(
      `${process.env.NEXT_PUBLIC_WEBSOCKET_API_ENDPOINT}/graphql-ws`,
      { reconnect: true }
    )
  );

  return split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
      );
    },
    wsLink,
    httpLink
  );
};
